(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/content/responsive-image/assets/javascripts/image-helpers.js') >= 0) return;  svs.modules.push('/components/content/responsive-image/assets/javascripts/image-helpers.js'); 'use strict';

function registerHelpers(hbs, config) {
  function isAbsoluteUrl(url) {
    return url && url.indexOf('http') === 0;
  }

  function getImageUrl(url, size) {
    url = isAbsoluteUrl(url) ? url : config.options.cdn2 + url;
    return url.replace('{width}', size);
  }

  hbs.registerHelper('imageSrcset', (image, extension) => {
    const srcset = [];
    const availableWidths = image.availableWidths || ['noAvailableWidths'];
    let imageUrl = image.url;

    if (typeof extension === 'string') {
      imageUrl = imageUrl.substring(0, imageUrl.lastIndexOf('.')) + extension;
    }

    availableWidths.forEach(size => {
      srcset.push("".concat(getImageUrl(imageUrl, size), " ").concat(size, "w"));
    });
    return new hbs.SafeString(srcset.join(','));
  });
}

if (svs.isServer) {
  registerHelpers(require('hbs'), require('trinidad-core').core.config);
} else {
  registerHelpers(Handlebars, {
    options: svs.core.config.data.svsconfig
  });
}
 })(window);